import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  Checkbox,
  Grid,
  Typography,
  Autocomplete,
  Pagination,
  Skeleton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import TablePagination from "@mui/material/TablePagination";
import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
import { FormatAmount } from "../FormatAmount";
import moment from "moment";
import * as XLSX from "xlsx";
import axios from "axios";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import { handleInvoiceClick } from "../CommonLink";
import EmptyData from "../../../StyledComponents/Table/EmptyData";
import { getRefrenceDataList } from "../../Invoices/actions";
import { getDemandTypes } from "../actions";

const useStyles = makeStyles(dashboardStyle);

const FormatDate = (dateString) => {
  if (!dateString) return null;
  const parsedDate = moment(dateString);
  const formattedDate = parsedDate.format("DD MMM YYYY");
  return formattedDate;
};

const defaultFormValues = {
  RowsOfPage: 25,
  PageNo: 1,
  venderName: "All",
  Vendor: {
    Vendor_Code: "-1",
    Vendor_Name: "",
  },
  // statusFilter: "All",
  statusFilter: { Status: "All" },
     invoice_Type: "",
     demand_Type : "",
       is_HR : "",
  PendingWith: "All",
  PhoneNumber: "All",
  startDate: undefined,
  endDate: undefined,
  sortColumn: undefined,
  invoiceNoFilter: undefined,
  isAsc: false,
};
const defaultFormValuesDownload = {
  venderName: undefined,
  Vendor: {
    Vendor_Code: "-1",
    Vendor_Name: "",
  },
  statusFilter: { Status: "All" },
  PendingWith: undefined,
  PhoneNumber: undefined,
  startDate: undefined,
  endDate: undefined,
  sortColumn: undefined,
  isAsc: false,
  isPdf: false,
   invoice_Type: "",
    demand_Type : "",
           is_HR : "",
};
const StatusInvoiceTable = ({
  header,
  dropdownValue,
  loading,
  setData,
  setLoading,
  data,
  page,
}) => {
  console.log("dataList", data);
  const [filteredData, setFilteredData] = useState(data);
  const [ReturedBy, setReturedBy] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const classes = useStyles();
  const [count, setCount] = useState(0);
  const [multipleData, setMultipleData] = useState({
      invoice_Type: [],
    });

  const [formState, setFormState] = useState(
    defaultFormValues || defaultFormValuesDownload
  );
  const demandTypeOptions = ["ALL", "HR", "OTHER"];

    const [vendors, setVendors] = useState([]);
    const [vendorLoading, setVendorLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);

    try {
      console.log("params", {
        pageNumber: formState?.PageNo,
        pageSize: 25,
        fromDate: params.startDate,
        toDate: params.endDate,
        vendorName:
          params?.Vendor?.Vendor_Name === "All" ? undefined : params?.Vendor?.Vendor_Name,
        status: params.statusFilter?.Status === "All" ? undefined : params.statusFilter?.Status,
         invoiceType : params.invoice_Type,
        pendingWith:
          params.PhoneNumber === "All" ? undefined : params.PhoneNumber,
        invoiceNo: params.invoiceNoFilter?.trim() || "",
        sortColumn: params.sortColumn,
        sortDirection: params.sortDirection,
      });
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Report/GetInvoiceStatus`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
          params: {
            pageNumber: params?.PageNo || 1,
            pageSize: params?.RowsOfPage || 25,
            fromDate: params.startDate || undefined,
            vendorName:
            (params?.Vendor?.Vendor_Name === "All" ||    params?.Vendor?.Vendor_Name === "" ) ? undefined :  params?.Vendor?.Vendor_Name,
            status:
            params.statusFilter?.Status === "All" ? undefined : params.statusFilter?.Status,
                 invoiceType : params?.invoice_Type === "" ? undefined :  params?.invoice_Type,
            pendingWith:
              params.PhoneNumber === "All" ? undefined : params.PhoneNumber || undefined,
            toDate: params.endDate || undefined,
            sortColumn: params.sortColumn,
            invoiceNo: params.invoiceNoFilter?.trim() || undefined,
            isAsc: params.isAsc,
            demandType : params?.demand_Type === "" ? undefined :  params?.demand_Type,
            isHR : params?.is_HR === "" ? undefined :  params?.is_HR,
       
            
          },
        }
      );
      console.log("res:", res);
      setData(res?.data?.response);
      setCount(res?.data?.totalCount);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const resetFilter = async () => {
    setFormState(defaultFormValues);
    await fetchData(defaultFormValues);
  };
  const [listStatus, setListStatus] = useState([]);
  const [categories, setCategories] = useState([]);
  const [returnList, setReturnList] = useState([]);

  useEffect(() => {
    const fetchData = async (url, setter) => {
      try {
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        });
        setter(response?.data); // Set the fetched data to the state
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // fetchData(
    //   `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getStatusListGroup`,
    //   setListStatus
    // );
    fetchData(
      `${process.env.REACT_APP_API_URL}/api/Report/GetPendingWithList`,
      setCategories
    );
    fetchData(
      `${process.env.REACT_APP_API_URL}/api/Report/GetReturnByList`,
      setReturnList
    );
  }, []);
  console.log("latest", data);
  const [userList, setUserList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage + 1,
    }));
  };

    useEffect(() => {
      fetchData(formState);
    }, [
      formState?.PageNo,
      formState?.RowsOfPage,
      formState.sortColumn,
      formState.isAsc,
    ]);

  const handleChangeRowsPerPage = (event) => {
    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
  };
  useEffect(() => {
  if(formState?.Vendor?.Vendor_Name !== "" ){
      fetchData(formState);
  }
  }, [
    formState?.PageNo,
    formState?.RowsOfPage,
    formState.sortColumn,
    formState.isAsc,
  ]);

  const handleSort = (index) => {
    if (index === formState.sortColumn) {
      setFormState((prevState) => ({
        ...prevState,
        isAsc: !prevState.isAsc,
      }));
    } else {
      setFormState((prevState) => ({
        ...prevState,
        sortColumn: index,
        isAsc: true,
      }));
    }
  };
  const fetchUserList = async (query) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getVendorDetails/${query ? query : null
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
      setUserList(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchChange = (value) => {
    setSearchQuery(value); // assuming this is how you filter userList
  };

  useEffect(() => {
    if (searchQuery.trim() !== "") {
      fetchUserList(searchQuery);
    } else {
      fetchUserList();
    }
  }, [searchQuery]);
  const [isPdfLoading, setIsPdfLoading] = useState(false); // State for PDF download loading
  const [isExcelLoading, setIsExcelLoading] = useState(false); // State for Excel download loading
  const [userListPending, setUserListPending] = useState([]);
  const [searchQueryPending, setSearchQueryPending] = useState("");

  const handleDownloadFile = async (params, fileType) => {
    if (fileType === "pdf") {
      setIsPdfLoading(true);
    } else if (fileType === "excel") {
      setIsExcelLoading(true);
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Report/DownloadInvoiceStatusPDFExcelFile`,
        {
          responseType: "blob",
          params: {
            fromDate: params?.startDate,
            toDate: params?.endDate,
            vendorName:
            params?.Vendor?.Vendor_Name=== "All" ? undefined :  params?.Vendor?.Vendor_Name,
            status:
            params.statusFilter?.Status === "All" ? undefined : params.statusFilter?.Status,
            pendingWith:
              params.PhoneNumber === "All" ? undefined : params.PhoneNumber,
            sortColumn: params?.sortColumn,
            isAsc: params?.isAsc,
            invoiceType : params?.invoice_Type === "" ? undefined :  params?.invoice_Type,
            invoiceNo: params.invoiceNoFilter?.trim(),
            isPdf: fileType === "pdf", // Set isPdf based on fileType
            demandType : params?.demand_Type === "" ? undefined :  params?.demand_Type,
            isHR : params?.is_HR === "" ? undefined :  params?.is_HR,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );

      // Create a blob object from the response data
      const blob = new Blob([response.data], {
        type:
          fileType === "pdf"
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        fileType === "pdf" ? `StatusInvoice.pdf` : "StatusInvoice.xlsx"
      );
      document.body.appendChild(link);
      link.click();
      if (fileType === "pdf") {
        setIsPdfLoading(false);
      } else if (fileType === "excel") {
        setIsExcelLoading(false);
      }
    } catch (error) {
      console.error(`Error downloading ${fileType} file:`, error);
      if (fileType === "pdf") {
        setIsPdfLoading(false);
      } else if (fileType === "excel") {
        setIsExcelLoading(false);
      }
    }
  };

  const handleDownloadExcel = () => {
    handleDownloadFile(formState, "excel");
  };

  const handleDownloadPDF = () => {
    handleDownloadFile(formState, "pdf");
  };

  const fetchUserListPending = async (query) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Authenticate/getUserDetails/${query ? query : "%20"
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
      setUserListPending(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  console.log("userList", userListPending)


  const handleSearchChangePending = (event, value) => {
    setSearchQueryPending(value);
  };

  useEffect(() => {
    if (searchQueryPending.trim() !== "") {
      fetchUserListPending(searchQueryPending);
    } else {
      fetchUserListPending();
    }
  }, [searchQueryPending]);

  var options = [
    { Status: "All" },
    ...listStatus.map(status => ({ Status: status?.StatusGroup }))
  ];

  const autocompleteChangeHandler = (name, value) => {
      setFormState((formState) => ({
        ...formState,
        [name]: value,
      }));
      const updatedFormState = {
        ...formState,
        [name]: value,
      };
  
    };

     useEffect(() => {
        if (vendors.length > 0 && vendors[0].Vendor_Code !== "-1") {
          const vendorsStrigify = JSON.stringify(vendors);
          const vendorsParse = JSON.parse(vendorsStrigify);
          vendorsParse.unshift({ Vendor_Code: "-1", Vendor_Name: "All" });
          setVendors(vendorsParse);
        }
      }, [vendors]);


        useEffect(() => {
          getVendorDetail(null, setVendors, setVendorLoading);
          getStatusList(null , setListStatus)
        
        }, []);

      const getVendorDetail = async (user, setUserData, setLoading) => {
        setLoading(true);
        //
        await axios({
          method: "get", //you can set what request you want to be
          url: `${
            process.env.REACT_APP_API_URL
          }/api/InvoiceDetails/getVendorDetails/${user ? user : null}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            "Content-Type": "application/json",
          },
        })
          .then(async (res) => {
            setUserData(res.data);
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
      
            // setErrorMessage("Invalid username or password");
          });
      };

      const getStatusList = async (status , setListStatus) => {
        setLoading(true);
        //
        await axios({
          method: "get", //you can set what request you want to be
          url: `${
            process.env.REACT_APP_API_URL
          }/api/InvoiceDetails/getStatusListGroup?filter=${status ? status : ""}`,

          // `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getStatusListGroup`}
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            "Content-Type": "application/json",
          },
        })
          .then(async (res) => {
            setListStatus(res.data);
                    setLoading(false);
           
          })
          .catch((err) => {
                    setLoading(false);
       
      
            // setErrorMessage("Invalid username or password");
          });
      };
  useEffect(()=>{
     getRefrenceDataList(
        "invoiceType",
        "invoice_Type",
        () => {},
        setMultipleData
      );

      getDemandTypes(
        setMultipleData
      )



  },[])

  console.log( data.length, " data.length")

  console.log(loading , "loading sss")
     
  return (
    <div>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <Typography>
             Vendor:
          </Typography>
          {/* <Autocomplete
  disablePortal
            options={[{ Vendor_Name: "All" }, ...userList]} // Include "All" option at the beginning
            getOptionLabel={(option) => option.Vendor_Name}
  size="small"
  value={
              formState.venderName === "All" // Check if "All" is selected
                ? { Vendor_Name: "All" }
      : userList.find(
          (option) => option.Vendor_Name === formState.venderName
        ) || null
  }
            onChange={(e, newValue) => {
              const selectedVendor = newValue?.Vendor_Name || null;
    setFormState((prevState) => ({
      ...prevState,
      venderName: selectedVendor,
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Select vendor"
    />
  )}
/> */} 


<Autocomplete
                    
                    id="Vendor"
                    options={vendors}
                    classes={{ option: classes.option }}
                    size="small"
                    name="Vendor"
                    value={formState.Vendor}
                    getOptionLabel={(option) =>
                      (option !== "" &&
                        `${
                          option?.Vendor_Code !== "-1"
                            ? `${option?.Vendor_Code}-`
                            : ""
                        }${option?.Vendor_Name}`) ||
                      ""
                    }
                    loading={vendorLoading}
                    onChange={(event, newValue) => {
                      autocompleteChangeHandler("Vendor", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        // sx={{ input: { color: "#888888" } }}
                        {...params}
                        name=""
                        required
                        value={""}
                        onChange={(event) => {
                          getVendorDetail(
                            event.target.value,
                            setVendors,
                            setVendorLoading
                          );
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <Typography>
            Status:
          </Typography>
          {/* <Autocomplete
            disablePortal
            options={options}
            getOptionLabel={(option) => option.Status}
            size="small"
            value={
              formState.statusFilter === "All"
                ? { Status: "All" }
                : options.find((option) => option.Status === formState.statusFilter)
            }
            onChange={(e, newValue) => {
              const selectedStatus = newValue ? newValue.Status : null
              setFormState((prevState) => ({
                ...prevState,
                statusFilter: selectedStatus,
              }));
            }}
            renderInput={(params) => <TextField {...params}
            />}
          /> */}

<Autocomplete
                    
                    id="statusFilter"
                    options={options}
                    getOptionLabel={(option) => option.Status}
                    classes={{ option: classes.option }}
                    size="small"
                    name="statusFilter"
                    value={
                      formState.statusFilter }
                   
                  
                    onChange={(event, newValue) => {
                      autocompleteChangeHandler("statusFilter", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        // sx={{ input: { color: "#888888" } }}
                        {...params}
                        name=""
                        required
                        value={""}
                        onChange={(event) => {
                          getStatusList(
                            event.target.value,
                            setListStatus,
                          
                          );
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
        </Grid>
        {dropdownValue == "InvoiceType" ? (
          <Grid item xs={12} sm={12} md={4} lg={3}>
            <Typography>
              <span className={classes.asterisk}>*</span> Retured By:
            </Typography>
            <Autocomplete
              disablePortal
              options={returnList}
              getOptionLabel={(option) => option?.ReturnBy}
              size="small"
              value={
                listStatus.find((option) => option?.ReturnBy === ReturedBy) ||
                null
              }
              onChange={(e, newValue) => {
                setReturedBy(newValue?.ReturnBy);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={dropdownValue === "InvoiceStatus" ? 3 : 3}
          >
            <Typography>
              Pending With:
            </Typography>
            <Autocomplete
              disablePortal
              options={[{ Name: "All" }, ...userListPending]}
              value={
                formState.PendingWith === "All"
                  ? { Name: "All" }
                  : userListPending.find(
                    (option) => option.Name === formState.PendingWith
                  ) || null
              }
              onChange={(e, newValue) => {
                const selectedPendingWith = newValue?.Name || null;
                setFormState((prevState) => ({
                  ...prevState,
                  PendingWith: selectedPendingWith,
                  PhoneNumber:
                    selectedPendingWith === "All"
                      ? undefined
                      : newValue?.PersonalNumber || "",
                }));
              }}
              getOptionLabel={(option) => option.Name}
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  onChange={(e) => handleSearchChangePending(e, e.target.value)}
                />
              )} />
          </Grid>
        )}
        {dropdownValue == "InvoiceStatus" ? (
          <Grid item xs={12} sm={12} md={4} lg={3}>
            <Typography>
              Invoice No :
            </Typography>
            <TextField
              variant="outlined"
              value={formState.invoiceNoFilter || ""}
              onChange={(e) => {
                setFormState((x) => ({
                  ...x,
                  invoiceNoFilter: e?.target?.value,
                }));
              }}
              fullWidth
              size="small"
            />
          </Grid>
        ) : null}
      </Grid>
      <Grid container spacing={2} mt={0} mb={5}>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>
            Start Date:
          </Typography>
          <TextField
            type="date"
            variant="outlined"
            fullWidth
            size="small"
            value={formState.startDate || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                startDate: e.target.value,
              }));
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>
            End Date:
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            variant="outlined"
            value={formState.endDate || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                endDate: e.target.value,
              }));
            }}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: "10px" }}
          />
        </Grid>
        <Grid   item
            xs={12}
            sm={12}
            md={4}
            lg={3}>
          <Typography style={{ color: "black" }}>
                                         Invoice Type:
                                       </Typography>
                                       <Autocomplete
                                        
                                         id="submitter_role"
                                         options={
                                           multipleData?.invoice_Type
                                         }
                                         size="small"
                                         value={{
                                           ReferenceCode: formState?.invoice_Type || "",
                                         }}
                                        //  disabled={disable}
                                         title="select select"
                                         getOptionLabel={(option) =>
                                           (option !== "" &&
                                             `${option?.ReferenceCode}`) ||
                                           ""
                                         }
                                         // loading={rolesLoading}
                                         onChange={(event, newValue) => {
                                          
                                           autocompleteChangeHandler("invoice_Type" , newValue?.ReferenceCode);
                                         }}
                                         renderInput={(params) => (
                                           <TextField
                                             {...params}
                                             type="text"
                                             name=""
                                             placeholder="Select a value"
                                             required={formState?.isProceed}
                                           />
                                         )}
                                       />
        </Grid>

           <Grid   item
            xs={12}
            sm={12}
            md={4}
            lg={3}>
          <Typography style={{ color: "black" }}>
                                         Demand Type:
                                       </Typography>
                                       {/* <Autocomplete
                                        
                                         id="submitter_role"
                                         options={
                                           multipleData?.demandTypes
                                         }
                                         size="small"
                                         value={{
                                           ReferenceCode: formState?.demand_Type || "",
                                         }}
                                        //  disabled={disable}
                                         title="select select"
                                         getOptionLabel={(option) =>
                                           (option !== "" &&
                                             `${option?.ReferenceCode}`) ||
                                           ""
                                         }
                                         // loading={rolesLoading}
                                         onChange={(event, newValue) => {
                                          
                                           autocompleteChangeHandler("demand_Type" , newValue?.ReferenceCode);
                                         }}
                                         renderInput={(params) => (
                                           <TextField
                                             {...params}
                                             type="text"
                                             name=""
                                             placeholder="Select a value"
                                             required={formState?.isProceed}
                                           />
                                         )}
                                       /> */}

                                       <Autocomplete
  id="submitter_role"
  options={multipleData?.demandTypes || []}  // fallback empty array
  size="small"
  value={formState?.demand_Type || ""}       // just the string
  getOptionLabel={(option) => option || ""}  // option is a string
  onChange={(event, newValue) => {
    autocompleteChangeHandler("demand_Type", newValue);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      type="text"
      placeholder="Select a value"
      required={formState?.isProceed}
    />
  )}
/>

        </Grid>
         <Grid item xs={12} sm={12} md={4} lg={3}>
          <Typography style={{ color: "black" }}>
            Is HR:
          </Typography>

          <Autocomplete
            id="is_hr"
            options={demandTypeOptions}
            size="small"
            value={formState?.is_HR || ""}
            getOptionLabel={(option) => option || ""}
            onChange={(event, newValue) => {
              autocompleteChangeHandler("is_HR", newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                type="text"
                placeholder="Select a value"
                required={formState?.isProceed}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={() => fetchData(formState)}
              >
                Filter
              </Button>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={resetFilter}
              >
                Reset Filter
              </Button>
            </div>
            <div>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={handleDownloadExcel}
                disabled={isExcelLoading}
              >
                {isExcelLoading ? "Downloading.." : "Download Excel"}
              </Button>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={() => handleDownloadPDF()}
                disabled={isPdfLoading}
              >
                {isPdfLoading ? "Downloading.." : "PDF Download"}
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>

      <Table style={{ width: "100%" }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
            {header.map((header, index) => (
              <TableCell key={index} >
                <div
                  style={{
                    display: "flex",
                    alignItems: "left",
                    justifyContent: "left",
                    cursor: "pointer",
                  }}
                >
                  {header.label}

                </div>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              {[...Array(header.length)].map((header, colIndex) => (
                <TableCell key={colIndex}>
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />{" "}
                  <Skeleton
                    variant="rectangular"
                    style={{ height: 48, marginBottom: "10px" }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ) : data.length > 0 ? (
            data?.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {header.map((header, colIndex) => (
                  <TableCell
                    key={colIndex}
                    align={header.key === "invoiceAmount" || header.key === "daysTaxLaps" ? "right" : "left"}
                  >
                    {header.key === "invoiceNo" ?
                      <div onClick={() => handleInvoiceClick(row?.role, row?.status, row?.invoice_ID, row?.vendorCode)} style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}>{row[header.key]}</div> : header.key === "invoiceDate" ||
                        header.key === "paymentDate" ||
                        header.key === "submissionDate"
                        ? FormatDate(row[header.key])
                        : header.key === "invoiceAmount"
                          ? FormatAmount(row[header.key])
                          : row[header.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ):(
            <TableRow>
            <TableCell colSpan={12}><EmptyData/></TableCell>
          </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[25, 50, 100, 500, 1000]}
        component="div"
        count={count}
        rowsPerPage={formState.RowsOfPage}
        page={parseInt(formState.PageNo) - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default StatusInvoiceTable;
